import React, { useMemo } from "react";
import Sidebar from "../component/common/Sidebar";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { mainLayoutStyle } from "../helpers/Constants";
import Header from "../component/common/Header";
import { useDispatch, useSelector } from "react-redux";
import { setShowNavbar } from "../redux/reducer/homeSlice";
import "./style.scss";
import NotFound from "pages/Notfound";
import { navLinkUsers } from "helpers/RoleAccessData";

export function MainLayout(props) {
  const outerTheme = createTheme({
    palette: {
      primary: {
        main: "#1A4BA1",
      },
      secondary: {
        main: "#FBFBFB",
      },
    },
  });

  const classes = mainLayoutStyle();
  
  const dispatch = useDispatch();
  const state = useSelector((state) => state?.home?.privileges);
  const selectedRole = useSelector((state) => state?.home?.role);
  const commonLoader = useSelector((state) => state?.home?.commonLoader);

  // const allPaths = useMemo(
  //   () =>
  //     navLinkUsers
  //       .flatMap((item) =>
  //         item.subNav
  //           ? [item.to, ...item.subNav.map((sub) => sub.to)]
  //           : [item.to]
  //       )
  //       .filter(Boolean),
  //   []
  // );

  // if (!allPaths.includes(window.location.pathname)) {
  //   return <NotFound />;
  // }

  return (
    <div className="mainLayout">
      <ThemeProvider theme={outerTheme}>
        <div style={{ zIndex: "1", position: "relative" }}>
          <Header />
        </div>
        <div className={classes.root + ""}>
          <Sidebar
            classes={classes}
            window={{ window }}
            privilegesData={state}
            style={{ zIndex: "1", position: "relative" }}
          />
          <main
            onClick={() => dispatch(setShowNavbar(false))}
            className={classes.content}
          >
            {props.children}
          </main>
        </div>
      </ThemeProvider>
    </div>
  );
}
